<style>
</style>
<template>
<div>
  <div>{{ value.addressName }}</div>
  <div>{{ value.street }} {{ value.streetNo }}</div>
  <div>{{ value.zipCode }} {{ value.postSite }}</div>
  <div>{{ country !== undefined && country != null ? country.native : '' }}</div>
</div>
</template>
<script>
import CountryMixin from '@gravela/vue-component-library/src/mixins/country-mixin.js'

export default {
  mixins: [CountryMixin],
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    country() {
      return this.countries.find(key => key.code === this.value.country)
    }
  }
}
</script>
